export type ColorTheme = "light" | "dark";

const THEME_COOKIE_NAME = "colorTheme";
const COOKIE_MAX_AGE_SECONDS = 31536000;

export const getColorThemeCookie = (): ColorTheme => {
    const value = document.cookie
        .split("; ")
        .find((row) => row.startsWith(`${THEME_COOKIE_NAME}=`))
        ?.split("=")[1];

    return value === "dark" ? "dark" : "light";
};

export const setColorThemeCookie = (theme: ColorTheme): void => {
    document.cookie = `${THEME_COOKIE_NAME}=${theme}; path=/; max-age=${COOKIE_MAX_AGE_SECONDS}; SameSite=Lax`;
};
